export default {
    instagram: "dtuneclothing",
    facebook: "dtuneclothing",
    telegram: "dtuneclothing",
    twitter: "dtuneclothing"
}